export default __webpack_public_path__ + "static/media/usa.4d9d9906.png";